var exports = {
  "k": "xfd349460--962d49--container",
  "n": "xfd349460--962d49--link",
};

module.exports = exports;
